import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from "@angular/forms";
import { FieldModel, GenericFormService } from "@cv-invision/cv.invision-views.ux";

@Component({
	selector: 'cv-select-button-field',
	templateUrl: './select-button-field.component.html',
	styleUrls: ['./select-button-field.component.scss'],
})
export class SelectButtonFieldComponent implements OnInit {
	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: FieldModel;
	@Input() value: any;
	@Input() show: any;
	@Input() active = false;

	constructor(private formService: GenericFormService) {
	}

	ngOnInit(): void {
		if (this.field.disabled) {
			this.control.disable();
		}
	}

	/**
	 * Trigger the field onChange
	 *
	 * @param $event
	 * @param field
	 * @param row
	 */
	onChange($event: any): void {
		if ('UIEvents' in this.field && this.field.UIEvents.onChange) {
			this.formService.onSwitchChange$.next({
				field: this.field,
				event: $event
			});
		}
	}
}
